import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './LoginModal.css';

export default function LoginModal({ isOpen, onClose, onSwitchToSignup }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  
  const { login, loginWithGoogle, isLoading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    const result = await login(email, password, rememberMe);
    
    if (result.success) {
      alert(`Welcome back, ${result.user.displayName || result.user.nickname || result.user.firstName}!`);
      onClose();
      navigate('/');
    } else {
      setError(result.error || 'Login failed. Please try again.');
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    
    try {
      // Trigger Google OAuth popup - the callback will handle the rest
      await loginWithGoogle();
      // Close modal immediately as the OAuth flow will handle login
      onClose();
    } catch (error) {
      setError('Google login failed. Please try again.');
    }
  };

  const handleFacebookLogin = () => {
    alert('Facebook authentication coming soon!');
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Welcome Back</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          {/* Social Login */}
          <div className="social-login">
            <button 
              className="btn-social google" 
              onClick={handleGoogleLogin}
              disabled={isLoading}
            >
              <span className="social-icon">G</span>
              <span>Continue with Google</span>
            </button>
            <button 
              className="btn-social facebook" 
              onClick={handleFacebookLogin}
            >
              <span className="social-icon">f</span>
              <span>Continue with Facebook</span>
            </button>
          </div>

          <div className="login-divider">
            <span>or</span>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="checkbox-group">
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="rememberMe">Remember me for 30 days</label>
            </div>

            <button 
              type="submit" 
              className="btn btn-primary login-btn"
              disabled={isLoading}
            >
              {isLoading ? 'Signing In...' : 'Log In'}
            </button>
          </form>

          <div className="modal-footer">
            <p className="signup-prompt">
              Don't have an account?
              <button 
                className="signup-link" 
                onClick={() => {
                  onClose();
                  onSwitchToSignup();
                }}
              >
                Sign up
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
